import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { createTenant } from '../../api/tenants';
import {
  Container,
  Typography,
  Box,
  Button,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import TenantForm from '../../components/admin/TenantForm';

const CreateTenant = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    setError(null);

    try {
      // Prepare tenant data
      const tenantData = {
        name: values.name,
        area: values.area || null,
        registration_number: values.registration_number || null,
        contact_info: values.contact_info || null,
        latitude: values.latitude !== '' && values.latitude != null ? parseFloat(values.latitude) : null,
        longitude: values.longitude !== '' && values.longitude != null ? parseFloat(values.longitude) : null,
        // Super-admin only. The API drops it for everyone else, so sending it
        // unconditionally is safe; omitting it is what silently broke the
        // checkbox, since this payload is built field-by-field rather than
        // spreading `values`.
        is_shadow: Boolean(values.is_shadow),
      };

      // Create tenant
      await createTenant(tenantData);
      
      // Navigate back to tenant list
      navigate('/admin/tenants');
    } catch (error) {
      console.error('Error creating tenant:', error);
      if (error.response && error.response.data && error.response.data.detail) {
        setError(error.response.data.detail);
      } else {
        setError('Failed to create tenant. Please try again later.');
      }
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin/tenants');
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Breadcrumbs sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/dashboard" color="inherit">
            Dashboard
          </Link>
          <Link component={RouterLink} to="/admin/tenants" color="inherit">
            Tenants
          </Link>
          <Typography color="text.primary">Create</Typography>
        </Breadcrumbs>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Create Tenant
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<ArrowBackIcon />}
            component={RouterLink}
            to="/admin/tenants"
          >
            Back to Tenants
          </Button>
        </Box>

        <TenantForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isSubmitting={isSubmitting}
          error={error}
        />
      </Box>
    </Container>
  );
};

export default CreateTenant;